define('videos.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('videos', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"videos-section\"><div data-view=\"Videos.Collection\"></div></div>";
},"useData":true}, 'extensions/Tavanoteam/Videos/1.0.2/', 'extensions/Tavanoteam/Videos/1.0.2/', Handlebars);
});